import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UniversityFinderFilter } from '../models/university-finder-filter.model';

/**
 * Shares the University Finder filter state between the landing page, the results page, and the filter-list
 * component. Mirrors {@link FlyingClubFinderFiltersService} (a root-provided BehaviorSubject).
 */
@Injectable({
  providedIn: 'root'
})
export class UniversityFinderFiltersService {

  private universityFinderFilterSubject$ = new BehaviorSubject<UniversityFinderFilter>(new UniversityFinderFilter());
  universityFinderFilter = this.universityFinderFilterSubject$.asObservable();

  constructor() { }

  updateUniversityFinderFilters(universityFinderFilter: UniversityFinderFilter) {
    this.universityFinderFilterSubject$.next(universityFinderFilter);
  }
}
